import './App.css';
import './LandingPage.css';
import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLayout from './components/AppLayout';
import { useActiveButton } from './ActiveButtonContext';
import { get } from '@aws-amplify/api';

const IronCondorMenu = ({ signOut }) => {
  const navigate = useNavigate();
  const { activeButton, setActiveButton } = useActiveButton();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleClick = (buttonName) => {
    setActiveButton(buttonName);
  };

  const navigateTo = (path) => {
    if (path === "/myPortfolioIronCondor") {
      navigate(path, { state: { icType: "LONG" } });
    } else {
      navigate(path);
    }
  };

  const handleQuickIronCondor = async (security) => {
    setLoading(true);
    setError('');

    try {
      const myAPI = "mktappapi";
      const path = '/getIronCondorOptionsLegs';
      const position = "LONG";
      const days = 30;
      const upperBound = 5;
      const lowerBound = 0.1;
      const profitAlert = 0;
      const contracts = 1;

      const passApiStr = `${path}/${position}/${days}/${security.toUpperCase()}/${upperBound}/${lowerBound}/${profitAlert}/${contracts}`;
      console.log("handleQuickIronCondor : passApiStr = ", passApiStr);

      const response = await get({
        apiName: myAPI,
        path: passApiStr,
      }).response;

      const optionsLegs = await response.body.json();
      console.log("handleQuickIronCondor : optionsLegs = ", optionsLegs);

      setLoading(false);

      if (optionsLegs && Object.keys(optionsLegs).length !== 0) {
        navigate("/ironCondorOptionsLegs", { state: { optionsLegs: optionsLegs } });
      } else {
        setError("No data received from API");
      }
    } catch (err) {
      console.error("handleQuickIronCondor : Error = ", err);
      setError(err.message || "Failed to load data");
      setLoading(false);
    }
  };

  const ActionButton = ({ onClick, title, tooltip, active }) => (
    <button
      onClick={onClick}
      title={tooltip}
      style={{
        padding: '12px 16px',
        background: active ? 'rgba(16, 185, 129, 0.1)' : 'rgba(59, 130, 246, 0.1)',
        border: active ? '1px solid rgba(16, 185, 129, 0.3)' : '1px solid rgba(59, 130, 246, 0.3)',
        borderRadius: '8px',
        color: active ? '#10b981' : '#3b82f6',
        fontSize: '14px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s',
        textAlign: 'center',
      }}
      onMouseEnter={(e) => {
        if (!active) {
          e.currentTarget.style.background = 'rgba(59, 130, 246, 0.2)';
        }
      }}
      onMouseLeave={(e) => {
        if (!active) {
          e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
        }
      }}
    >
      {title}
    </button>
  );

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Page Title */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
            Reverse Iron Condor Strategy
          </h1>
        </div>

        {/* Loading and Error Messages */}
        {loading && (
          <div className="blink_me" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px',
            background: 'rgba(59, 130, 246, 0.1)',
            borderRadius: '8px'
          }}>
            Getting IC Data...
          </div>
        )}
        {error && (
          <div className="blink_me_red" style={{
            marginBottom: '16px',
            textAlign: 'center',
            fontSize: '16px',
            padding: '12px'
          }}>
            {error}
          </div>
        )}

        {/* Custom Reverse Iron Condor Section */}
        <div className="landing-panel" style={{ marginBottom: '24px' }}>
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">🎯 Custom Reverse Iron Condor</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <ActionButton
                onClick={() => navigateTo('/generateOptionsLegs')}
                title="Generate Options Legs"
                tooltip="Create custom reverse iron condor with adjustable parameters"
              />
              <ActionButton
                onClick={() => navigateTo('/findEtfsForIc')}
                title="Find ETFs for Iron Condor"
                tooltip="Discover suitable ETFs for iron condor strategies"
              />
            </div>
          </div>
        </div>

        {/* Quick Iron Condor Section */}
        <div className="landing-panel">
          <div className="landing-panel-header">
            <h2 className="landing-panel-title">⚡ Quick Iron Condor</h2>
          </div>
          <div className="landing-panel-content">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <ActionButton
                onClick={() => handleQuickIronCondor('SPY')}
                title="Long SPY 30 Days / Upper 5% / Lower 0.1%"
                tooltip="Pre-configured SPY reverse iron condor"
              />
              <ActionButton
                onClick={() => handleQuickIronCondor('QQQ')}
                title="Long QQQ 30 Days / Upper 5% / Lower 0.1%"
                tooltip="Pre-configured QQQ reverse iron condor"
              />
              <ActionButton
                onClick={() => handleQuickIronCondor('IWM')}
                title="Long IWM 30 Days / Upper 5% / Lower 0.1%"
                tooltip="Pre-configured IWM reverse iron condor"
              />
            </div>
          </div>
        </div>
      </div>
    </AppLayout>
  );
}

export default IronCondorMenu;